import { IComment, ICommentCreate, ICommentUpdate, ICommentResponse } from "src/@types/comment";
import { Tags } from "../enum/tags";
import { apiSlice } from "./http";

const ENDPOINTS = {
  COMMENTS: "/comments-divergence",
  DIVERGENCE: (id: number) => `/comments-divergence/divergence/${id}`,
} as const;

export const commentInformations = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getComments: builder.query<ICommentResponse, { divergence_id: number }>({
      query: ({ divergence_id }) => ({ url: ENDPOINTS.DIVERGENCE(divergence_id), method: "GET" }),
      providesTags: [Tags.DIVERGENCE],
    }),
    createComment: builder.mutation<IComment, ICommentCreate>({
      query: (body) => ({ url: ENDPOINTS.COMMENTS, method: "POST", body }),
      invalidatesTags: [Tags.DIVERGENCE],
    }),
    updateComment: builder.mutation<IComment, ICommentUpdate>({
      query: (body) => ({ url: `${ENDPOINTS.COMMENTS}/${body.id}`, method: "PUT", body }),
      invalidatesTags: [Tags.DIVERGENCE],
    }),
    deleteComment: builder.mutation<void, { id: number }>({
      query: ({ id }) => ({ url: `${ENDPOINTS.COMMENTS}/${id}`, method: "DELETE" }),
      invalidatesTags: [Tags.DIVERGENCE],

    }),
  }),
});

export const {
  useGetCommentsQuery,
  useCreateCommentMutation,
  useUpdateCommentMutation,
  useDeleteCommentMutation,
} = commentInformations;